import { loadStylesheet } from 'components/storefront/editor/easyblocks-page/parser/utils';
import { getAttributeValue } from './utils';

/** @typedef {import('components/storefront/editor/easyblocks-page/asset-loader').default} AssetLoader */

/**
 * @param {AssetLoader} assetLoader
 */
function processStylesheet(assetLoader) {
  return {
    selector: 'link[rel="stylesheet"]',
    remove: true,
    processNode(node) {
      const href = getAttributeValue(node, 'href');

      const loader = loadStylesheet(href);

      if (loader) {
        assetLoader.addContentAsset(loader);
      }
    },
  };
}

export default processStylesheet;
